import React from 'react';
import PageActionBar from 'components/PageActionBar';
import Card from 'components/Card';
import MessageBox from 'components/MessageBox';
import TextArea from 'components/TextArea';
import ColoredButton from 'components/ColoredButton';
import { getRole } from '../../../../reducers';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './styles.scss';
import contentAreaStyles from 'styles/contentArea';
import cx from 'classnames';
import { requestbulkProjectLoad } from 'actionCreators';

const BulkProjectsLoad = (props) => {
  const [jobs, setJobs] = React.useState('');
  const [details, setDetails] = React.useState('');
  const [workorders, setWorkorders] = React.useState('');
  const [error, setError] = React.useState('');
  const [success, setSuccess] = React.useState('');
  const loadProjects = () => {
    const jobsArray = jobs.split(/[\n|\n\r|,|\s]/).filter(j => j !== '');
    const detailsArray = details.split(/[\n|\n\r|,|\s]/).filter(j => j !== '');
    const workordersArray = workorders.split(/[\n|\n\r|,|\s]/).filter(j => j !== '');
    props.requestbulkProjectLoad({
      jobs: jobsArray,
      details: detailsArray,
      workorders: workordersArray,
    })
      .then(() => { setError(''); setSuccess('Projects scheduled for loading.'); })
      .catch(e => setError(e.payload.errors));
  };

  return (<div>
    <PageActionBar
      role={props.role}
      title={'Bulk Project Load'}
      showAdd={false}
      showFiltersBtn={false}
    />
    <div className={contentAreaStyles.contentAreaContainer}>
      <Card>
        <div className={styles.content_area}>
          <p className={styles.explanation}>Input project numbers separated
          by a comma or a new line</p>
          <TextArea
            className={styles.text_area}
            label="Jobs"
            value={jobs}
            onChange={e => setJobs(e.target.value)}
            autoFocus
          />
          <TextArea
            label="Details"
            value={details}
            onChange={e => setDetails(e.target.value)} className={styles.text_area}
          />
          <TextArea
            label="Workorders"
            value={workorders}
            onChange={e => setWorkorders(e.target.value)} className={styles.text_area}
          />
          <ColoredButton disabled={!jobs && !details && !workorders} onClick={loadProjects} color="green" label="Load Projects" responsive className={styles.button} />
          <MessageBox
            className={cx({
              [styles.messageBox]: true,
              [styles.visible]: error || success,
            })} message={error || success} error={error}
          />
        </div>
      </Card>
    </div>
  </div>);
};

BulkProjectsLoad.propTypes = {
  role: PropTypes.string,
  requestbulkProjectLoad: PropTypes.func,
};


const mapStateToProps = state => ({
  role: getRole(state),
});

export default connect(mapStateToProps, {
  requestbulkProjectLoad,
})(BulkProjectsLoad);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/bulkProjectsLoad/index.jsx